<script setup lang="ts">
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { onMounted, onUnmounted, reactive } from 'vue';
import { eventEmitter } from '@/lib/eventEmitter.ts';

export type CommonAlertPayloadType = {
    title?: string;
    description?: string;
    actionText?: string;
    cancelText?: string;
    continueCallback?: () => void;
    cancelCallback?: () => void;
};

interface ComponentState {
    isOpen: boolean;
    dialogTitle?: string;
    dialogDescription?: string;
    dialogActionText?: string;
    dialogCancelText?: string;
    continueCallback?: () => void;
    cancelCallback?: () => void;
}

const state: ComponentState = reactive({
    isOpen: false,
    dialogTitle: undefined,
    dialogDescription: undefined,
    dialogActionText: undefined,
    dialogCancelText: undefined,
    continueCallback: undefined,
    cancelCallback: undefined,
});

const openModal = (payload: CommonAlertPayloadType) => {
    state.dialogTitle = payload.title;
    state.dialogDescription = payload.description;
    state.dialogActionText = payload.actionText;
    state.dialogCancelText = payload.cancelText;
    state.continueCallback = payload.continueCallback;
    state.cancelCallback = payload.cancelCallback;
    state.isOpen = true;
};

onMounted(async () => {
    eventEmitter.addListener('showAlertDialog', openModal);
});

onUnmounted(() => {
    eventEmitter.removeListener('showAlertDialog', openModal);
});
</script>

<template>
    <AlertDialog v-model:open="state.isOpen">
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ state.dialogTitle ?? 'Are you sure?' }}</AlertDialogTitle>
                <AlertDialogDescription>
                    {{ state.dialogDescription ?? 'This action cannot be undone.' }}
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel @click="state.cancelCallback">
                    {{ state.dialogCancelText ?? 'Cancel' }}</AlertDialogCancel
                >
                <AlertDialogAction @click="state.continueCallback">
                    {{ state.dialogActionText ?? 'Continue' }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
